import gql from 'graphql-tag';

export const QUERY_PLAN = gql`
  query plan($id: String) {
    referralCommissionPlan(id: $id) {
      name
      id
    }
  }
`;

export const QUERY_COMMISSION_PLANS = gql`
  query plans(
    $searchName: NonEmptyString
    $pageSize: Int!
    $pageNumber: Int!
    $sortBy: [ReferralCommissionPlanSortBy!]
    $countryCode: NonEmptyString
  ) {
    referralCommissionPlans(
      searchName: $searchName
      pageSize: $pageSize
      pageNumber: $pageNumber
      sortBy: $sortBy
      countryCode: $countryCode
    ) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          default
          externalName
          id
          name
          createdAt
          updatedAt
          countryCode
          countryHasDefault
          currency
          updatedUser {
            firstName
            lastName
          }
          country {
            name
            partnerCommissionCalculation {
              calculationPeriodStart
              calculationPeriodEnd
              leaseThresholdValue
              leaseThresholdUnit
              paymentCurrency
            }
          }
          tiers {
            shortTermCalculationValue
            longTermCalculationValue
            bookingCountTo
            bookingCountFrom
            name
            calculationRules {
              leaseType
              tenancyLengthFrom
              tenancyLengthTo
              calculationValue
              calculationType
            }
          }
        }
      }
    }
  }
`;

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int, $countrySlugs: [String]) {
    countries(pageNumber: $pageNumber, pageSize: $pageSize, countrySlugs: $countrySlugs) {
      edges {
        node {
          name
          id
          countryCode
          currencyCode
          slug
          partnerCommissionCalculation {
            calculationPeriodStart
            calculationPeriodEnd
            leaseThresholdValue
            leaseThresholdUnit
            paymentCurrency
          }
        }
      }
    }
  }
`;

export const QUERY_CHECK_DEFAULT_PLAN = gql`
  query defaultPlan($countryCode: NonEmptyString) {
    getCountryDefaultReferralCommissionPlan(countryCode: $countryCode) {
      id
      name
      countryCode
      currency
    }
  }
`;

export const QUERY_CHECK_NAME = gql`
  query checkname($name: NonEmptyString) {
    checkReferralCommissionPlanNameExists(name: $name) {
      exists
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation createPlan($input: CreateReferralCommissionPlanInput) {
    createReferralCommissionPlan(input: $input) {
      id
      name
      externalName
      tiers {
        name
      }
    }
  }
`;

export const UPDATE_PLAN = gql`
  mutation updatePlan($input: UpdateReferralCommissionPlanInput) {
    updateReferralCommissionPlan(input: $input) {
      name
      id
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
      }
    }
  }
`;

export const DELETE_PLAN = gql`
  mutation deletePlan($id: String!) {
    deleteReferralCommissionPlan(id: $id) {
      id
      externalName
      name
    }
  }
`;
